import { get } from 'svelte/store';
import axios from 'axios';
// import { signOutUser } from '@ctm/auth';
import { accessToken } from '$lib/stores/user';

const { interceptors } = axios;
let cancelTokens = [];

interceptors.request.use(
	async (config) => {
		if (config.isAuthenticated) {
			config.headers['Authorization'] = `Bearer ${get(accessToken)}`;

			if (config.method === 'post') {
				config.headers['Content-Type'] = 'application/json';
			}
		}

		if (config.apiVersion) {
			config.headers['X-API-Version'] = config.apiVersion;
		}

		if (config.cancelKey) {
			const source = axios.CancelToken.source();
			config.cancelToken = source.token;

			cancelTokens.forEach((cancelToken, index, array) => {
				if (cancelToken.key === config.cancelKey) {
					cancelToken.source.cancel();
					array.splice(index, 1);
				}
			});

			cancelTokens.push({
				key: config.cancelKey,
				source,
			});
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

interceptors.response.use(
	(response) => {
		if (response.config.cancel) {
			const cancelTokensForKey = cancelTokens.filter((cancelToken) => {
				return (cancelToken.key = response.config.cancelKey);
			});

			if (cancelTokensForKey.length === 1) {
				cancelTokens = cancelTokens.filter((cancelToken) => {
					return cancelToken.key !== response.config.cancelKey;
				});
			}
		}

		return response;
	},
	(error) => {
		// FIXME: why was this commented out? is it still needed?
		// should 401 log the user out?
		//
		// if (!axios.isCancel(error)) {
		//   if (error.response && error.response.status === 401) {
		//     signOutUser('sessionExpired');
		//   }
		// }

		return Promise.reject(error);
	},
);

export default interceptors;
